import { render, staticRenderFns } from "./details-dialog.vue?vue&type=template&id=79a655ac&scoped=true"
import script from "./details-dialog.vue?vue&type=script&lang=js"
export * from "./details-dialog.vue?vue&type=script&lang=js"
import style0 from "./details-dialog.vue?vue&type=style&index=0&id=79a655ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a655ac",
  null
  
)

export default component.exports